import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from '../network/index';
import { useAuth } from './AuthContext';

const WarehouseContext = createContext();

export const useWarehouse = () => {
  return useContext(WarehouseContext);
};

export const WarehouseProvider = ({ children }) => {
  const [warehouses, setWarehouses] = useState(() => {
    // Get stored warehouses from localStorage if available
    const storedWarehouses = localStorage.getItem('warehouses');
    return storedWarehouses ? JSON.parse(storedWarehouses) : [];
  });

  const [warehouseId, setWarehouseId] = useState(() => {
    // Get stored warehouse ID from localStorage if available
    return localStorage.getItem('warehouseId') || null;
  });

  const { token } = useAuth();

  useEffect(() => {
    const fetchWarehouses = async () => {
      if (!token) return;

      // If warehouses are already in localStorage, avoid API call
      if (warehouses.length > 0) return;

      try {
        const response = await axios.get('/warehouses/getWarehousesForUser/json', {
          params: {
            access_token: token || localStorage.getItem('authToken'),
          },
        });
        const warehouseData = response.data.Data;

        setWarehouses(warehouseData);
        localStorage.setItem('warehouses', JSON.stringify(warehouseData)); // Store warehouses locally

        if (warehouseData.length > 0) {
          setWarehouseId(warehouseData[0].id);
          localStorage.setItem('warehouseId', warehouseData[0].id); // Store warehouseId locally
        }
      } catch (error) {
        console.error('Error fetching warehouses:', error);
      }
    };

    fetchWarehouses();
  }, [token]);

  const selectWarehouse = (id) => {
    setWarehouseId(id);
    localStorage.setItem('warehouseId', id); // Update the local storage with the new warehouse ID
  };

  return (
    <WarehouseContext.Provider value={{ warehouses, warehouseId, selectWarehouse }}>
      {children}
    </WarehouseContext.Provider>
  );
};
